<template>
	<EventTeamLayout
		:event="event"
		:subtitle="trans('events.teams.standings.title')"
		:teams="teams"
		:team-count="teamCount"
		:can-create="canCreate"
		:selected-tab="selectedTab"
		:title="trans('events.teams.standings.title')"
	>
		<div class="w-full overflow-x-auto">
			<table v-if="!canCreate" class="table-auto border-collapse">
				<thead>
					<tr>
						<th class="px-3 py-2 text-left" colspan="2">{{ trans('events.teams.scores.team') }}</th>
						<th class="px-3 py-2 w-[100px]">{{ trans('events.teams.scores.points') }}</th>
						<th class="px-3 py-2 w-[100px]">{{ trans('events.teams.scores.advantage') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(team, teamIndex) in teams" :key="`team-${team.id}`" class="bg-gray-100 dark:bg-gray-900">
						<td v-if="teamIndex + 1 === 1" class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">
							<i class="fa-solid fa-award text-amber-300"/>
						</td>
						<td v-else-if="teamIndex + 1 === 2" class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">
							<i class="fa-solid fa-award text-gray-500"/>
						</td>
						<td v-else-if="teamIndex + 1 === 3" class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">
							<i class="fa-solid fa-award text-amber-800"/>
						</td>
						<td v-else class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">{{ teamIndex + 1 }}</td>
						<td class="px-3 py-2 border-y dark:border-gray-700">{{ team.name }}</td>
						<td class="px-3 py-2 border-y dark:border-gray-700 text-center">{{ team.score }}</td>
						<td class="px-3 py-2 border-y dark:border-gray-700 text-center">{{ team.advantage_score }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</EventTeamLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {ref, type Ref, defineProps} from 'vue'
import {type Event} from '@/Types/Events/Event'
import {type Team} from '@/Types/Events/Teams/Team'
import EventTeamLayout from '@/Layouts/EventTeamLayout.vue'

const props = defineProps<{
	event: Event,
	teams: Array<Team>,
	teamCount: number,
	canCreate: boolean,
	selectedTab: string,
}>()

const event: Ref<Event> = ref(props.event)
const teams: Ref<Array<Team>> = ref(props.teams)
const canCreate: Ref<boolean> = ref(props.canCreate)
const selectedTab: Ref<string> = ref(props.selectedTab)
</script>